<template>
  <UiDropdown v-if="systemUpdate.hasUpdate" ref="dropdown" class="w-full mb-2">
    <template #default>
      <button class="relative w-full bg-amber-200 border border-amber-400 text-amber-800 py-2 px-4 rounded-md text-left" v-tooltip :title="$t(compact ? 'versionManager.newAvailable' : '')">
        <div class="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
        <div class="flex gap-2 overflow-hidden">
          <UiIcon icon="devices-exclamation" :size="24" class="shrink-0" />
          <span v-if="!compact" class="truncate">{{ $t('versionManager.newAvailable') }}</span>
        </div>
      </button>
    </template>
    <template #content>
      <div class="p-2 text-xs leading-3 max-w-48 text-center">
        <div class="font-semibold mb-1">{{ $t('versionManager.newAvailable') }}</div>
        <div>{{ $t('versionManager.newInstructions') }}</div>
        <UiButton type="primary" class="px-2 py-1 mt-2" @click="reload">
          {{ $t('versionManager.update') }}
        </UiButton>
      </div>
    </template>
  </UiDropdown>
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'
// import { initializeApp } from 'firebase/app'
// import { getDatabase, ref as dbRef, onValue } from 'firebase/database'

import UiDropdown from '@/components/ui/dropdown.vue'
import UiIcon from '@/components/ui/icon.vue'
import UiButton from '@/components/ui/button.vue'
import { version } from '@/version'

// const dropdown = ref<InstanceType<typeof UiDropdown> | null>(null)

const { compact = false } = defineProps<{
  compact?: boolean
}>()

const systemUpdate = inject('app.systemUpdate', ref({
  hasUpdate: false,
  hash: ''
}))

// const firebaseConfig = {
//   databaseURL: 'https://plantartest-5f920-default-rtdb.firebaseio.com'
// }

// const app = initializeApp(firebaseConfig)

// const db = getDatabase(app)
// const sysVersionRef = dbRef(db, 'sysVersion')

// onValue(sysVersionRef, (snapshot) => {
//   console.log('Checking for version updates...')
//   const data = snapshot.val()

//   console.log('Current version:', version)
//   console.log('Fetched version:', data)

//   if (data && data !== version) {
//     systemUpdate.value.hasUpdate = true
//   }
// })

const reload = () => {
  if (systemUpdate.value.hash) {
    localStorage.setItem('version', systemUpdate.value.hash) 
  }
  window.location.reload()
}
</script>